module.exports = __webpack_public_path__ + "static/media/daniela.45fa22c1.png";